import './CookiesPolicy.css';
import {Helmet} from "react-helmet-async";

export default function CookiesPolicy() {
    return <div id='cookies-policy'>
        <Helmet>
            <title>Polityka cookies | Lumestore</title>
            <meta name="description" content="Informacje o plikach cookies używanych w Lumestore." />
            <meta name="robots" content="noindex,follow" />
            <link rel="canonical" href="https://lumestore.pl/ciasteczka" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Polityka cookies | Lumestore" />
            <meta property="og:description" content="Informacje o plikach cookies używanych w Lumestore." />
            <meta property="og:url" content="https://lumestore.pl/ciasteczka" />
        </Helmet>
        <h1>Polityka cookies sklepu internetowego Lume Store</h1>

        <h2>§ 1. Czym są pliki cookies?</h2>
        <p>
            Pliki cookies to niewielkie pliki tekstowe zapisywane na urządzeniu użytkownika
            podczas korzystania ze strony internetowej.
        </p>

        <h2>§ 2. Cele wykorzystywania cookies</h2>
        <p>Sklep wykorzystuje pliki cookies w następujących celach:</p>
        <ol>
            <li>prawidłowego działania strony,</li>
            <li>zapamiętywania preferencji użytkownika,</li>
            <li>analizy ruchu na stronie (Google Analytics lub podobne narzędzia),</li>
            <li>działań marketingowych i remarketingowych.</li>
        </ol>

        <h2>§ 3. Rodzaje cookies używanych w sklepie</h2>
        <ol>
            <li><strong>Niezbędne</strong> – umożliwiają prawidłowe funkcjonowanie sklepu,</li>
            <li><strong>Analityczne</strong> – pomagają zrozumieć, jak użytkownicy korzystają ze strony,</li>
            <li><strong>Marketingowe</strong> – umożliwiają wyświetlanie spersonalizowanych reklam.</li>
        </ol>

        <h2>§ 4. Zarządzanie cookies</h2>
        <p>
            Użytkownik może w każdej chwili zmienić ustawienia cookies w swojej przeglądarce internetowej.
            Ograniczenie stosowania cookies może wpłynąć na niektóre funkcjonalności sklepu.
        </p>

        <h2>§ 5. Podmioty trzecie</h2>
        <p>Na stronie mogą być stosowane pliki cookies podmiotów trzecich, takich jak:</p>
        <ol>
            <li>Google (np. Google Analytics),</li>
            <li>Meta (Facebook Pixel),</li>
            <li>operatorzy płatności online.</li>
        </ol>

        <h2>§ 6. Jak wyłączyć cookies?</h2>
        <p>
            Większość przeglądarek internetowych umożliwia usunięcie lub blokadę plików cookies.
            Instrukcje można znaleźć w pomocy przeglądarki (np. Chrome, Firefox, Safari).
        </p>

    </div>;
}
